<template>
  <el-switch
    v-model="switchValue"
    active-color="#409EFF"
    inactive-color="#91939A"
    @change="changeValue">
  </el-switch>
</template>
<script>
export default {
  props: {
    value: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      switchValue: this.value
    }
  },
  watch: {
    value(status) {
      if(status !== this.switchValue) {
        this.switchValue = status
      }
    }
  },
  methods: {
    changeValue(status) {
      this.$emit('input', status)
      this.$emit('change', status)
    }
  }
}
</script>